'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ReviewsListStats from 'marketplace-ui-reviews/components/ReviewsListStats';
import ReviewsHeader from 'marketplace-ui-reviews/components/ReviewsHeader';
import ReviewsFilterSortDropdowns from 'marketplace-ui-reviews/components/ReviewsFilterSortDropdowns';
import ReviewsPaginatedList from 'marketplace-ui-reviews/components/ReviewsPaginatedList';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import { PAGE_KEY, SEARCH_KEY } from 'marketplace-ui-reviews/constants/ReviewsListQueries';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
import { resetProfileReviewFilters, resetProfileReviewsStatus, resetProfileReviewStatsStatus, updateReviewFilters } from '../../actions/ReviewActions';
import { getReviews, getReviewTotal, getReviewsRequestState, getReviewStats, getReviewFilters } from '../../selectors/reviews';
import { getServices } from '../../slices/serviceCatalogSlice';
import ProfileReviewRenderer from './ProfileReviewRenderer';

const ReviewsCardBody = ({
  onTrackInteraction,
  scrollToTabSection
}) => {
  const {
    inline
  } = useResponsiveProps({
    inline: {
      xs: false,
      lg: true
    }
  });
  const [searchSubmitted, setSearchSubmitted] = useState('');
  const dispatch = useDispatch();
  const reviewsRequestState = useSelector(getReviewsRequestState);
  const reviews = useSelector(getReviews);
  const reviewStats = useSelector(getReviewStats);
  const reviewSearchTotal = useSelector(getReviewTotal);
  const reviewFilters = useSelector(getReviewFilters);
  const catalogServices = useSelector(getServices);
  useEffect(() => {
    return () => {
      dispatch(resetProfileReviewsStatus());
      dispatch(resetProfileReviewStatsStatus());
      dispatch(resetProfileReviewFilters());
    };
  }, [dispatch]);
  const handleTrackInteraction = useCallback((action, extras = {}) => {
    onTrackInteraction(action, Object.assign({}, extras, {
      section: 'reviews'
    }));
  }, [onTrackInteraction]);
  const onUpdateFilters = useCallback(({
    textKey,
    value
  }) => {
    handleTrackInteraction(`change reviews ${textKey}`, {
      value: `${value}`
    });

    if (textKey === PAGE_KEY) {
      scrollToTabSection('reviews');
    }

    if (textKey === SEARCH_KEY) {
      setSearchSubmitted(value);
    }

    dispatch(updateReviewFilters({
      [textKey]: value
    }));
  }, [dispatch, handleTrackInteraction, scrollToTabSection]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ReviewsListStats, {
      className: "m-y-6",
      inline: inline,
      onUpdateFilters: onUpdateFilters,
      reviewStats: reviewStats,
      reviewType: ReviewTypes.PROFILE
    }), /*#__PURE__*/_jsx(ReviewsHeader, {
      onUpdateFilters: onUpdateFilters,
      reviewsCount: reviewStats.get('count'),
      reviewFilters: reviewFilters
    }), /*#__PURE__*/_jsx(ReviewsFilterSortDropdowns, {
      catalogServices: catalogServices,
      onUpdateFilters: onUpdateFilters,
      reviewFilters: reviewFilters,
      reviewStats: reviewStats
    }), /*#__PURE__*/_jsx(ReviewsPaginatedList, {
      onUpdateFilters: onUpdateFilters,
      ReviewRenderer: ProfileReviewRenderer,
      reviews: reviews,
      reviewsFetchStatus: reviewsRequestState,
      reviewFilters: reviewFilters,
      reviewsTotal: reviewSearchTotal,
      searchTerm: searchSubmitted
    })]
  });
};

ReviewsCardBody.propTypes = {
  onTrackInteraction: PropTypes.func.isRequired,
  scrollToTabSection: PropTypes.func.isRequired
};
export default ReviewsCardBody;